import * as firebase from 'firebase/app'
import * as React from 'react'
import { RouteComponentProps } from 'react-router-dom'

import { IInvoice } from 'interfaces/IInvoice'
import { IInvoiceItem } from 'interfaces/IInvoiceItem'
import { formatCurrency, nameof } from 'utils'

import { IAuthState } from 'containers/Auth'
import AuthContext, { IAuthContext } from 'context/AuthContext'

// const getExpire = (company: ICompany | null) =>
//   new Date(Date.now() + (company ? company.paymentdays * 86400000 : 0))
//     .toISOString()
//     .substr(0, 10)

interface IState {
  invoice: IInvoice
}

class InvoiceEditor extends React.Component<
  RouteComponentProps<{ id: string }> & {
    company: IAuthState['company']
    companies: IAuthState['companies']
    clients: IAuthContext['clients']
  },
  IState
> {
  public state: IState = {
    invoice: {
      client: {
        adress: '',
        city: '',
        name: '',
        reference: '',
        zip: '',
      },
      clientKey: this.parseClientKey,
      date: '',
      expire: '',
      number: '',
    } as IInvoice,
  }

  get parseClientKey(): string {
    if (this.props.location.search.includes('?clientKey=')) {
      return this.props.location.search.replace('?clientKey=', '')
    }

    return ''
  }

  public async componentDidMount() {
    const { currentUser } = firebase.auth()
    const { props } = this

    if (props.match.params.id && currentUser) {
      const snapshot = await firebase
        .database()
        .ref(
          `/invoices/${currentUser.uid}/${props.company}/${props.match.params.id}`
        )
        .once('value')

      if (snapshot.val()) {
        this.setState(state => ({
          invoice: { ...state.invoice, ...snapshot.val() },
        }))
      }
    } else if (props.company) {
      const { paymentdays } = props.companies[props.company]

      this.setState(state => ({
        invoice: {
          ...state.invoice,
          date: new Date().toISOString().substr(0, 10),
          expire: new Date(Date.now() + paymentdays * 24 * 60 * 60 * 1000)
            .toISOString()
            .substr(0, 10),
        },
      }))
    }
  }

  public handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()

    const { currentUser } = firebase.auth()
    const { props, state } = this
    const { id } = props.match.params

    if (!currentUser) {
      throw new Error('No UID')
    }

    // TODO: Do this?
    const invoice: IInvoice = {
      ...state.invoice,
      items: [...(state.invoice.items || [])].filter(item => item.description),
    }

    if (!id) {
      invoice.unpaid = true
    }

    // TODO: Only set needed company properties
    if (props.company && !invoice.company) {
      invoice.company = props.companies[props.company]
    }

    if (id) {
      firebase
        .database()
        .ref(`/invoices/${currentUser.uid}/${props.company}/${id}`)
        .set(invoice)
        .then(() => props.history.push('/invoices'))
    } else {
      firebase
        .database()
        .ref(`/invoices/${currentUser.uid}/${props.company}/`)
        .push(invoice)
        .then(() => props.history.push('/invoices'))
    }
  }

  public handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.currentTarget

    this.setState({ invoice: { ...this.state.invoice, [name]: value } })
  }

  public handleItemChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { value: initialValue, type } = e.currentTarget

    const [index, name] = e.currentTarget.name.split('|')

    const items = [...(this.state.invoice.items || ([] as IInvoiceItem[]))]
    const item: IInvoiceItem = items[index] || {}

    const value =
      type === 'number' ? parseFloat(initialValue) || 0 : initialValue

    items[index] = {
      ...item,
      [name]: value,
    }

    items[index] = {
      ...items[index],
      sum: Math.round(items[index].num * items[index].price),
    }

    this.setState({
      invoice: {
        ...this.state.invoice,
        items,
      },
    })
  }

  public handleClientSelect = (e: React.ChangeEvent<HTMLSelectElement>) => {
    this.setState({
      invoice: {
        ...this.state.invoice,
        client: this.props.clients[e.currentTarget.value],
        clientKey: e.currentTarget.value,
      },
    })
  }

  public addItem = () => {
    this.setState({
      invoice: {
        ...this.state.invoice,
        items: [
          ...(this.state.invoice.items || []),
          {
            description: '',
            moms: 25,
            num: 1,
            price: 400,
            sum: 400,
            text: '',
          },
        ],
      },
    })
  }

  public removeItem = (item: number) => {
    const items = [...(this.state.invoice.items || [])]

    items.splice(item, 1)

    this.setState({
      invoice: {
        ...this.state.invoice,
        items,
      },
    })
  }

  get sum(): number {
    let sum = 0

    const { items } = this.state.invoice

    if (items) {
      items.forEach(item => (sum += item.sum))
    }

    return Math.round(sum)
  }

  get moms(): number {
    let moms = 0

    const { items } = this.state.invoice

    if (items) {
      items.forEach(item => (moms += item.sum * (item.moms / 100)))
    }

    return Math.round(moms)
  }

  get topay(): number {
    return Math.round(this.sum + this.moms)
  }

  public sortClients = (a: string, b: string) =>
    this.props.clients[a].name > this.props.clients[b].name ? 1 : -1

  public render() {
    const { props, state } = this

    return (
      <form onSubmit={this.handleSubmit}>
        <div id="invoiceClient">
          <h3>Kund</h3>
          <select
            name="client"
            onChange={this.handleClientSelect}
            value={state.invoice.clientKey}
          >
            <option disabled value="">
              Välj en kund
            </option>
            {Object.keys(props.clients)
              .sort(this.sortClients)
              .map(id => (
                <option value={id} key={id}>
                  {props.clients[id] && props.clients[id].name}
                  {' - '}
                  {props.clients[id] && props.clients[id].reference}
                </option>
              ))}
          </select>
          <div className="spacer" />
        </div>
        <table className="clean">
          <tbody>
            <tr>
              <td>
                <h3>Fakturanummer</h3>
              </td>
              <td>
                <h3>Fakturadatum</h3>
              </td>
              <td>
                <h3>Förfallodatum</h3>
              </td>
              <td>
                <h3>Valuta</h3>
              </td>
            </tr>
            <tr>
              <td>
                <input
                  type="text"
                  style={{ width: 160 }}
                  name={nameof<IInvoice>('number')}
                  value={state.invoice.number}
                  onChange={this.handleChange}
                />
              </td>
              <td>
                <input
                  type="text"
                  style={{ width: 100, textAlign: 'center' }}
                  name={nameof<IInvoice>('date')}
                  value={state.invoice.date}
                  onChange={this.handleChange}
                />
              </td>
              <td>
                <input
                  type="text"
                  style={{ width: 100, textAlign: 'center' }}
                  name={nameof<IInvoice>('expire')}
                  value={state.invoice.expire}
                  onChange={this.handleChange}
                />
              </td>
              <td>
                <select
                  name={nameof<IInvoice>('currency')}
                  value={state.invoice.currency}
                  onChange={this.handleChange}
                >
                  <option value="SEK">SEK</option>
                  <option value="NOK">NOK</option>
                  <option value="EUR">EUR</option>
                </select>
              </td>
            </tr>
          </tbody>
        </table>
        <div className="divider" />
        <table id="invoice" className="clean">
          <tbody>
            <tr>
              <td>
                <h3>Beskrivning</h3>
              </td>
              <td>
                <h3>Antal</h3>
              </td>
              <td>
                <h3>À-pris</h3>
              </td>
              <td>
                <h3>Moms %</h3>
              </td>
              <td>
                <h3>Summa</h3>
              </td>
            </tr>
            {state.invoice.items &&
              state.invoice.items.map((item, index) => (
                <tr className="item" key={index}>
                  <td>
                    <input
                      type="text"
                      style={{ width: 300 }}
                      name={index + '|' + nameof<IInvoiceItem>('description')}
                      value={item.description}
                      onChange={this.handleItemChange}
                    />
                    <br />
                    <textarea
                      name={index + '|' + nameof<IInvoiceItem>('text')}
                      onChange={this.handleItemChange}
                      style={{ width: 300, height: 'auto' }}
                      rows={2}
                      value={item.text}
                    />
                  </td>
                  <td>
                    <input
                      type="number"
                      style={{ width: 40, textAlign: 'center' }}
                      name={index + '|' + nameof<IInvoiceItem>('num')}
                      value={item.num}
                      onChange={this.handleItemChange}
                      step=".1"
                    />
                  </td>
                  <td>
                    <input
                      type="number"
                      style={{ width: 50, textAlign: 'center' }}
                      name={index + '|' + nameof<IInvoiceItem>('price')}
                      value={item.price}
                      onChange={this.handleItemChange}
                    />
                    {' kr'}
                  </td>
                  <td>
                    <input
                      type="number"
                      style={{ width: 50, textAlign: 'center' }}
                      name={index + '|' + nameof<IInvoiceItem>('moms')}
                      value={item.moms}
                      onChange={this.handleItemChange}
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      style={{ width: 100, textAlign: 'right' }}
                      name={index + '|' + nameof<IInvoiceItem>('sum')}
                      value={formatCurrency(item.sum, state.invoice.currency)}
                      onChange={this.handleItemChange}
                      readOnly
                    />
                  </td>
                  <td>
                    <a onClick={() => this.removeItem(index)}>Ta bort rad</a>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
        <br />
        <a onClick={this.addItem}>Lägg till rad</a>
        <div className="divider" />
        <table className="clean">
          <tbody>
            <tr>
              <td>
                <h3>Summa</h3>
              </td>
              <td>
                <h3>Moms</h3>
              </td>
              <td>
                <h3>Att betala</h3>
              </td>
            </tr>
            <tr>
              <td>
                <input
                  type="text"
                  style={{ width: 120, textAlign: 'right' }}
                  readOnly
                  value={formatCurrency(this.sum, state.invoice.currency)}
                />
              </td>
              <td>
                <input
                  type="text"
                  style={{ width: 120, textAlign: 'right' }}
                  readOnly
                  value={formatCurrency(this.moms, state.invoice.currency)}
                />
              </td>
              <td>
                <input
                  type="text"
                  style={{ width: 120, textAlign: 'right' }}
                  readOnly
                  value={formatCurrency(this.topay, state.invoice.currency)}
                />
              </td>
            </tr>
          </tbody>
        </table>
        <div className="submit">
          <button className="button" disabled={!state.invoice.clientKey}>
            <span>Spara</span>
          </button>
        </div>
      </form>
    )
  }
}

export default (props: RouteComponentProps<{ id: string }>) => (
  <AuthContext.Consumer>
    {({ company, companies, clients }) => (
      <InvoiceEditor
        {...props}
        company={company}
        companies={companies}
        clients={clients}
      />
    )}
  </AuthContext.Consumer>
)



// WEBPACK FOOTER //
// ./src/components/InvoiceEditor/InvoiceEditor.tsx